module.exports = __webpack_public_path__ + "static/img/31-1.939b676.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/31-1.jpg
// module id = 4P+K
// module chunks = 0